module.exports = __webpack_public_path__ + "static/jj-155740f6a16a494df4c665dcb2b7d0d2.jpg";